<template>
    <div class="back-perfil">
        <div class="container pb-5 px-2">
            <div class="criar-conta mt-4">
                <h2 class="text-center text-white"><strong>Confirmar Cadastro</strong></h2>

                <div class="dados-conta bg-white mt-5 mt-md-3 rounded p-2 shadow">
                    <div class="font-cna my-0 mx-auto m-md-3">
                        <div class="media">
                            <div class="media-body pr-md-4">
                                <form ref="confirmar-cadastro"
                                      v-on:submit.prevent="executeEdit(model)"
                                      novalidate
                                      class="form-group mt-3">

                                    <div class="mt-3">
                                        <div class="editando-perfil w-100">

                                            <div class="row pl-md-3">
                                                <div class="form-group form-group-custom col-md-12">
                                                    <label for="nome" class="bmd-label-floating">Usuário</label>
                                                    <input type="text"
                                                           class="form-control"
                                                           name="nome"
                                                           autocomplete="off"
                                                           v-model="model.usuario"
                                                           required />
                                                </div>
                                            </div>
                                            <div class="row pl-md-3">
                                                <div class="form-group form-group-custom col-md-12">
                                                    <label for="nome" class="bmd-label-floating">Senha</label>
                                                    <input type="password"
                                                           class="form-control"
                                                           name="nome"
                                                           autocomplete="off"
                                                           v-model="model.senha"
                                                           required />
                                                </div>
                                            </div>
                                            <div class="row pl-md-3" v-if="model.senha">
                                                <div class="form-group form-group-custom col-md-12">
                                                    <label for="nome" class="bmd-label-floating">Confirmar Senha</label>
                                                    <input type="password"
                                                           class="form-control"
                                                           name="nome"
                                                           autocomplete="off"
                                                           v-model="model.confirmarsenha"
                                                           required />
                                                </div>
                                            </div>

                                            <div class="col-md-6 mt-4">
                                                <div class="alert alert-secondary text-center">
                                                    <strong>Dica de segurança</strong><br />
                                                    <span class="small">Crie uma senha com no mínimo 6 caracteres.</span>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="w-100 pr-3">
                                        <button type="button"
                                                class="btn btn-primary btn-round float-right mt-3 ml-3"
                                                @click="executeEdit(model)">
                                            Confirmar
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
    import { Api } from "@/common/api";
    import base from "@/common/base";
    import Global from '@/common/global'

    export default {
        name: "confirmar-cadastro",
        mixins: [base],
        components: {},
        data: () => ({
            id: null,
            usuario: null,
            form: "confirmar-cadastro",

            model: {
                usuario: '',
                senha: '',
                confirmarsenha: '',
                pessoaCNAId: ''
            },

        }),
        methods: {
            executeEdit() {
                if (this.formValidate() == false) return;
                this.showLoading();

                new Api("pessoacnaacesso/ConfiguraNovoUsuario").get(this.model).then(
                    (data) => {
                        this.defaultSuccessResult(
                            "Seu cadastro foi atualizado com sucesso"
                        );

                        var url = Global.URL_CNA_NET

                        window.location = url + "?cadastroconfirmado=true";
                    },
                    (err) => {
                        this.defaultErrorResult(err);
                    }
                );
            },

            formValidate() {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                var _valid = $form.checkValidity();
                return _valid;
            },
        },

        mounted() {
            this.id = this.$route.params.id;
            this.usuario = this.$route.params.usuario;

            this.model.usuario = this.usuario;
            this.model.pessoaCNAId = this.id;
        },
    };
</script>